import { Controller } from "@hotwired/stimulus"
import { Current } from "current.js";
import { ethers } from "ethers";

// Connects to data-controller="staking"
export default class extends Controller {
  static targets = ["nftInput", "wallet", "stakeBtn", "stakeBtnText", "nftImg", "nftImgTxt"]

  async connect() {
    const somnia_chain_id = 5031
    this.nft_id = 0;
    this.provider = new ethers.BrowserProvider(window.ethereum);
    this.signer = await this.provider.getSigner();
    this.nft = await this.#getNftContract()
    this.staking = await this.#getStakingContract()

    const network = await this.provider.getNetwork()
    this.is_wrong_chain = network.chainId != somnia_chain_id ? true : false

    if (this.is_wrong_chain) {
      toast('Wrong blockchain chain detected', { type: 'error', description: 'Please switch chain to Somnia Mainnet' })
      return;
    }
  }

  async search() {
    const id_input = this.nftInputTarget
    const id = this.nftInputTarget.value
    const wallet = this.walletTarget.value
    const stake_btn = this.stakeBtnTarget
    const stake_btn_txt = this.stakeBtnTextTarget
    const stake_img = this.nftImgTarget
    const stake_img_txt = this.nftImgTxtTarget

    if (this.is_wrong_chain) {
      toast('Wrong blockchain chain detected', { type: 'error', description: 'Please switch chain to Somnia Mainnet' })
      return;
    }

    if (id === "") {
      toast('No NFT ID found', { type: 'error', description: 'Please provide correct NFT ID.' })
      this.nftInputTarget.value = ""
      return;
    }

    if (id <= 0) {
      toast("ID can't be below zero or be zero", { type: 'error', description: 'Please provide correct NFT ID.' })
      this.nftInputTarget.value = ""
      return;
    }

    if (id > 1193) {
      toast("ID above collection limit", { type: 'error', description: 'Please provide correct NFT ID.' })
      this.nftInputTarget.value = ""
      return;
    }

    showLoading("Checking NFT Ownership")
    try {
      const owner = await this.nft.ownerOf(id)

      if (owner.toUpperCase() == wallet.toUpperCase()) {
        toast('NFT Found', { type: 'success', description: "Your nft has been found, stake button has been activated." })
        this.nft_id = id

        id_input.disabled = true
        stake_btn.disabled = false
        stake_img.src = `https://ipfs.io/ipfs/QmbnysxVotw1juoq6eBtZapqpw6NLHqTGVbuRFsKgHJKEK/${id}`
        stake_btn_txt.textContent = `Stake NFT #${id}`
        stake_img_txt.textContent = `Found Your NFT #${id}`
      } else {
        toast('Not NFT Owner', {
          type: 'error',
          description: 'Please check if given NFT ID is correct and you own it on this account.',
        })
      }
    } catch (e) {
      toast('Bad NFT ID', {
        type: 'error',
        description: 'It seems there has been error on the smart contract.',
      })
    }
    hideLoading()

    this.nftInputTarget.value = ""
  }

  async stake() {
    if (this.nft_id == 0) {
      toast("NFT ID is wrong", { type: 'error', description: 'Please refresh and try again.' })
      return;
    }

    showLoading("Approving NFT")
    try {
      const approveTx = await this.nft.approve(this.staking.target, this.nft_id)
      await approveTx.wait()

      showLoading("Staking NFT")
      const stakeTx = await this.staking.stake(this.nft_id)
      await stakeTx.wait()

      toast('Successfully Staked NFT', {
        type: 'success',
        description: 'SomeGorillas NFT has been staked, refreshing page.',
      })

      setTimeout(() => { window.location.reload() }, 500);
    } catch (e) {
      toast('Something happened...', {
        type: 'error',
        description: 'User may have rejected the action or contract issue happened.',
      })
    }
    hideLoading()
  }

  async #getNftContract() {
    const nft_abi = [
      "function totalSupply() view returns (uint256)",
      "function balanceOf(address owner) view returns (uint256)",
      "function ownerOf(uint256 tokenId) view returns (address)",
      {
        inputs: [
          { internalType: "address", name: "to", type: "address" },
          { internalType: "uint256", name: "tokenId", type: "uint256" },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
    ];

    return new ethers.Contract(Current.address.nft, nft_abi, this.signer);
  }

  async #getStakingContract() {
    const staking_abi = [
      { inputs: [{ internalType: "uint256", name: "nftId", type: "uint256" }], name: "stake", outputs: [], stateMutability: "nonpayable", type: "function" },
      "function getUserStakes(address _user) view returns (uint256[] memory)",
      {
        inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        name: "stakes",
        outputs: [
          { internalType: "address", name: "owner", type: "address" },
          { internalType: "uint64", name: "start", type: "uint64" },
          { internalType: "uint64", name: "unlock", type: "uint64" },
          { internalType: "uint128", name: "bananaClaimed", type: "uint128" },
        ],
        stateMutability: "view",
        type: "function",
      },
      {
        inputs: [{ internalType: "uint256", name: "nftId", type: "uint256" }],
        name: "bananaPending",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
      },
    ];

    return new ethers.Contract(Current.address.staking, staking_abi, this.signer);
  }
}
